module.exports = __webpack_public_path__ + "static/media/Surance-pattern.706fcd88.svg";